import React from "react";
import { Image } from "react-konva";
import useImage from "use-image";
import Konva from "konva";

export function getCrop(imageWidth, imageHeight) {
  const aspectRatio = imageWidth / imageHeight;

  let newWidth;
  let newHeight;

  const imageRatio = imageWidth / imageHeight;

  if (aspectRatio >= imageRatio) {
    newWidth = imageWidth;
    newHeight = imageWidth / aspectRatio;
  } else {
    newWidth = imageHeight * aspectRatio;
    newHeight = imageHeight;
  }

  const x = (imageWidth - newWidth) / 2;
  const y = (imageHeight - newHeight) / 2;

  return {
    x: x,
    y: y,
    width: newWidth,
    height: newHeight,
  };
}

export class Background extends React.Component {
  state = {
    image: null,
  };

  componentDidMount() {
    this.loadImage();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.src !== this.props.src) {
      this.loadImage();
    }
  }

  componentWillUnmount() {
    this.image.removeEventListener("load", this.handleLoad);
  }

  loadImage() {
    this.image = new window.Image();
    this.image.src = this.props.src;
    this.image.addEventListener("load", this.handleLoad);
  }

  handleLoad = () => {
    this.setState({
      image: this.image,
    });
  };

  render() {
    const imageWidth =
      this.state.image?.width || this.props.renderResolution.width;
    const imageHeight =
      this.state.image?.height || this.props.renderResolution.height;

    const crop = getCrop(imageWidth, imageHeight);

    return (
      <Image
        width={this.props.renderResolution.width}
        height={this.props.renderResolution.height}
        crop={crop}
        image={this.state.image}
        ref={(node) => {
          this.imageNode = node;
        }}
      />
    );
  }
}

export const MaskImage = ({ item, color, setArea, renderResolution }) => {
  const [image] = useImage(item.img, "anonymous");
  const imageRef = React.useRef();

  React.useEffect(() => {
    if (image) {
      imageRef.current.cache();
      imageRef.current.drawHitFromCache();
    }
  }, [image, renderResolution]);

  const crop = getCrop(image?.width, image?.height, renderResolution);

  return (
    <Image
      ref={imageRef}
      image={image}
      crop={crop}
      filters={[Konva.Filters.RGBA]}
      red={color?.r}
      blue={color?.b}
      green={color?.g}
      applyCache
      applyHitFromCache
      width={renderResolution?.width}
      height={renderResolution?.height}
      opacity={color ? 0.48 : 0}
      onClick={() => setArea(item.id)}
    />
  );
};

export function svgToURL() {
  const svg =
    '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<circle cx="14" cy="14" r="14" fill="white" fill-opacity="0.5"/>\n' +
    '<circle cx="14.0007" cy="14" r="11.6316" fill="white"/>\n' +
    '<path d="M9.44022 17.1997L12.5037 20.2632L15.2268 17.5401C15.2715 17.4954 15.3246 17.4599 15.383 17.4357C15.4414 17.4115 15.504 17.399 15.5672 17.399C15.6304 17.399 15.693 17.4115 15.7514 17.4357C15.8098 17.4599 15.8629 17.4954 15.9076 17.5401M9.44022 17.1997L7.73828 15.4977L10.4614 12.7746C10.5061 12.7299 10.5416 12.6769 10.5658 12.6185C10.59 12.5601 10.6024 12.4975 10.6024 12.4343C10.6024 12.371 10.59 12.3084 10.5658 12.25C10.5416 12.1916 10.5061 12.1386 10.4614 12.0939M9.44022 17.1997L10.8018 15.8381M15.9076 17.5401C15.9523 17.5848 16.0053 17.6202 16.0637 17.6444C16.1222 17.6686 16.1848 17.6811 16.248 17.6811C16.3112 17.6811 16.3738 17.6686 16.4322 17.6444C16.4906 17.6202 16.5437 17.5848 16.5884 17.5401L18.1494 15.9791C18.277 15.8514 18.3487 15.6783 18.3487 15.4977C18.3487 15.3172 18.277 15.1441 18.1494 15.0164L16.7293 13.5963C16.6017 13.4687 16.53 13.2955 16.53 13.115C16.53 12.9345 16.6017 12.7614 16.7293 12.6337L19.1705 10.1925C19.2982 10.0648 19.3699 9.89167 19.3699 9.71116C19.3699 9.53064 19.2982 9.35751 19.1705 9.22985L18.7716 8.83091C18.6439 8.70329 18.4708 8.63159 18.2903 8.63159C18.1098 8.63159 17.9367 8.70329 17.809 8.83091L15.3677 11.2722C15.2401 11.3998 15.0669 11.4715 14.8864 11.4715C14.7059 11.4715 14.5328 11.3998 14.4051 11.2722L12.985 9.85208C12.8574 9.72445 12.6842 9.65275 12.5037 9.65275C12.3232 9.65275 12.1501 9.72445 12.0224 9.85208L10.4614 11.4131C10.4167 11.4578 10.3812 11.5109 10.357 11.5693C10.3328 11.6277 10.3204 11.6903 10.3204 11.7535C10.3204 11.8167 10.3328 11.8793 10.357 11.9377C10.3812 11.9961 10.4167 12.0492 10.4614 12.0939M15.9076 17.5401L10.4614 12.0939" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    "</svg>";
  const uri = window.btoa(unescape(encodeURIComponent(svg)));
  return "data:image/svg+xml;base64," + uri;
}
